import { ClientPoolStatus, PoolStatus } from '@/types/pool';
import { UserClientRole } from '@/types/user';
import { getPoolStatus, getPoolStatusConfig } from '@/utils/poolStatus';

type PoolStatusPillProps = {
  status: PoolStatus | ClientPoolStatus;
  isInvestor: boolean;
  counterOffer?: boolean;
};

export default function PoolStatusPill({ status, isInvestor, counterOffer }: PoolStatusPillProps) {
  const clientStatus = getPoolStatus(status, !!counterOffer);
  const config = getPoolStatusConfig(clientStatus);

  // Determine mode: use provided mode, or determine from user, or default to borrower
  const viewMode: UserClientRole = isInvestor ? UserClientRole.INVESTOR : UserClientRole.BORROWER;

  return (
    <div
      className={`inline-flex items-center gap-1.5 ${config.padding} ${config.bgColor} rounded-full ${config.fontSize} font-medium`}
      style={{
        fontFamily: 'var(--ep-font-avenir)',
      }}
    >
      <div className={`w-2 h-2 ${config.dotColor} rounded-full`} />
      <span className="text-black">{config.label[viewMode]}</span>
    </div>
  );
}
